var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomework(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1362",
    "data-name": "Rectangle 1362",
    width: 32,
    height: 18,
    transform: "translate(-0.456 -0.104)",
    fill: "#fff",
    opacity: 0.8
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7712",
    "data-name": "Group 7712",
    transform: "translate(-1055 -1189)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1361",
    "data-name": "Rectangle 1361",
    width: 32,
    height: 32,
    rx: 10,
    transform: "translate(1055 1189)",
    fill: "#d28f52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "training-course",
    d: "M186.52,184.406a4.109,4.109,0,0,1,2.146,3.612.649.649,0,0,1-1.3,0,2.812,2.812,0,1,0-5.625,0,.649.649,0,0,1-1.3,0,4.109,4.109,0,0,1,2.146-3.612,2.812,2.812,0,1,1,3.928,0Zm-1.964-.5a1.515,1.515,0,1,0-1.515-1.515A1.515,1.515,0,0,0,184.556,183.907Zm-2.014-5.833h-8.55a.677.677,0,0,1,0-1.35h8.549a.677.677,0,0,1,0,1.35Zm-3.664,3.031h-4.885a.677.677,0,0,1,0-1.35h4.885a.677.677,0,0,1,0,1.35Zm-.112,6.176a.693.693,0,1,1,0,1.384h-5.554a2.542,2.542,0,0,1-2.546-2.538V173.2a2.542,2.542,0,0,1,2.546-2.538h11.106a2.542,2.542,0,0,1,2.547,2.538v4.616a.694.694,0,0,1-1.389,0V173.2a1.155,1.155,0,0,0-1.157-1.155H173.214a1.156,1.156,0,0,0-1.157,1.155v12.922a1.155,1.155,0,0,0,1.157,1.155h5.553Z",
    transform: "translate(891.334 1025.333)",
    fill: "#fcfdfe",
    stroke: "#f8fafc",
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomework);
export default __webpack_public_path__ + "static/media/homework.27c01d895064a6e38d7a419996f60aa4.svg";
export { ForwardRef as ReactComponent };